import { FOLDER_COLOR_KEYS, FOLDER_COLORS, type FolderColor } from '@regia/shared';
import { useId } from 'react';
import { cn, folderStyle } from '../../ui';

/** Scelta del colore della cartellina: ogni campione è una piccola cartellina. */
export function ColorPicker({
  value,
  onChange,
}: {
  value: FolderColor;
  onChange: (c: FolderColor) => void;
}) {
  const name = useId();
  return (
    <fieldset className="grid grid-cols-5 gap-2.5">
      <legend className="sr-only">Colore della cartellina</legend>
      {FOLDER_COLOR_KEYS.map((key) => {
        const selected = key === value;
        return (
          <label
            key={key}
            style={folderStyle(key)}
            title={FOLDER_COLORS[key].label}
            className={cn(
              'relative flex h-12 cursor-pointer items-end justify-center rounded-xl transition-transform active:scale-95 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-action',
              selected && 'ring-2 ring-ink ring-offset-2 ring-offset-sheet',
            )}
          >
            <input
              type="radio"
              name={name}
              value={key}
              checked={selected}
              onChange={() => onChange(key)}
              aria-label={FOLDER_COLORS[key].label}
              className="sr-only"
            />
            <span
              className="absolute top-1.5 left-2 h-2.5 w-6 rounded-t-[5px] bg-[var(--folder)] brightness-90"
              aria-hidden
            />
            <span className="h-8 w-full rounded-lg bg-[var(--folder)]" aria-hidden />
          </label>
        );
      })}
    </fieldset>
  );
}
